import temperatureEnum from '../enums/temperatureEnum';
import { getDateTimeFromMillisecondsTZ } from './dateFormatter';

let imageInfo = {};

export default function buildImageInfo(imageJson, temperature = temperatureEnum.FAHRENHEIT) {
  imageJson?.image_info &&
    imageJson?.image_info.forEach((item) => {
      switch (item.type) {
        case 'milliseconds':
          attachValueToImageInfo(
            item.name,
            getDateTimeFromMillisecondsTZ(item.value, imageJson.main.user_timezone),
          );
          break;
        case 'date':
          attachValueToImageInfo(
            item.name,
            deprecatedGetDateTime(item.value, imageJson.main.user_timezone),
          );
          break;
        case 'string':
          attachValueToImageInfo(item.name, `${item.value}`);
          break;
        case 'temperature':
          attachValueToImageInfo(item.name, `${item.value[temperature]} ${temperature}`);
          break;
        case 'temperature_range':
          attachValueToImageInfo(
            item.name,
            `${item.value[temperatureEnum.FROM][temperature]} ${temperature} to ${
              item.value[temperatureEnum.TO][temperature]
            } ${temperature}`,
          );
          break;
        default:
          return imageInfo;
      }
    });
  return imageInfo;
}

const attachValueToImageInfo = (name, value) =>
  (imageInfo = {
    ...imageInfo,
    [name]: value,
  });

const deprecatedGetDateTime = (date, userTimezone) => {
  if (typeof date === 'number') {
    return getDateTimeFromMillisecondsTZ(date, userTimezone);
  }

  let parseDate = date.split('T');
  let newDate = `${parseDate[0]} ${parseDate[1]} UTC`;
  return new Date(newDate).toLocaleString(navigator.language, {
    timeZone: userTimezone,
    timeZoneName: 'short',
  });
};
